import PropTypes from 'prop-types';

export default (function (props, propName, componentName) {
  for (var _len = arguments.length, restArgs = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    restArgs[_key - 3] = arguments[_key];
  }

  if (process.env.SKIP_CLASSNAME_CHECK !== 'true') {
    if (process.env.NODE_ENV !== 'production') {
      if (props[propName]) {
        console.warn('Warning: `className` prop supplied to ' + componentName + ' component.\nCustom styling via `className` prop is not recommended. Keep in mind that the internal implementation of the component might change \nwhich can cause unexpected issues when styling via `className`');
      }
    }
  }
  return PropTypes.string.apply(PropTypes, [props, propName, componentName].concat(restArgs));
});